import { MultiValuesNode } from '../../types/chartDataTypes';
import { withGroupInfo, withoutLeafNodes } from '../../shared/helper/chartDataHelper';

export type BalanceSheetData = {
  assets: MultiValuesNode,
  liabilitiesAndReserves: MultiValuesNode,
  allTableData: MultiValuesNode,
  barChart: MultiValuesNode,
};

export const prepareData = (data: MultiValuesNode[]): BalanceSheetData => {
  const barData: MultiValuesNode = withGroupInfo({
    values: {},
    entries: data,
  } as MultiValuesNode);

  const tableData = withoutLeafNodes(barData);
  const assetData: MultiValuesNode = {
    entries: [tableData.entries[0]],
  };
  const lrData = tableData.entries[1];

  return {
    assets: assetData,
    liabilitiesAndReserves: lrData,
    barChart: barData,
    allTableData: tableData,
  };
};
